<h1 class="titulo">Firmantes</h1>
<mat-list role="list" class="lista">
    <mat-list-item role="listitem" *ngFor="let item of firmantes">
        <div matLine>
            <div style="width: 70%; float:left">
                <p class="{{ item.style }}">{{ item.nombreParticipante }} - <strong>{{ item.tipoParticipante }}</strong></p>
            </div>
            <div style="width: 30%; float:right">
                <ul class="list-unstyled">
                    <li *ngIf="item.estatus == 'PENDING'" class="liEstadoPendiente">
                        <span style="display: inline">
                            <small class="label labelPendiente">Pendiente</small>
                       </span>
                    </li>
                    <li *ngIf="item.estatus == 'SIGNED'" class="liEstadoFirmado">
                        <span style="display: inline">
                            <small class="label labelFirmado">Firmado</small>
                       </span>
                    </li>
                    <li *ngIf="item.estatus == 'CANCELLED'" class="liEstadoCancelado">
                        <span style="display: inline">
                            <small class="label labelCancelado">Rechazado</small>
                       </span>
                    </li>
                </ul>
            </div>
        </div>
    </mat-list-item>
</mat-list>